'use client'

import type { LinkHoverPrefetchProps } from '@pearlconvert/ui/components/link/link-hover-prefetch.types'

import NextLink from 'next/link'

import { useLinkHoverPrefetch } from '@pearlconvert/ui/components/link/batons/use-link-hover-prefetch'

export function LinkHoverPrefetch({
  href,
  target,
  children,
  className,
  scroll,
  onMouseEnter,
  ...props
}: LinkHoverPrefetchProps) {
  const { hovered, handleMouseEnter } = useLinkHoverPrefetch(onMouseEnter)

  return (
    <NextLink
      className={className}
      target={target}
      href={href}
      scroll={scroll}
      prefetch={hovered ? null : false}
      onMouseEnter={handleMouseEnter}
      {...props}
    >
      {children}
    </NextLink>
  )
}
